import React from 'react';
import './search.css'


const Search = (props) => {


    return (  

            <div className="search-wrapper">
      
{props.icon && (
  <span className="search-icon">
    <img src={props.icon} alt="search" />
  </span>
)}
            <input className='inputt2' type={props.type} 
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}/>
              </div>
    );
}
 
export default Search;